import {
    FETCH_DAILY_SLEEP_DATA_WITH_EPOCHS_FETCHING,
    FETCH_DAILY_SLEEP_DATA_WITH_EPOCHS_SUCCESS,
    FETCH_DAILY_SLEEP_DATA_WITH_EPOCHS_FAIL,
    UPDATE_SLEEP_NOTE_START,
    UPDATE_SLEEP_NOTE_SUCCESS,
    UPDATE_SLEEP_NOTE_FAIL,
    UPDATE_SLEEP_WINDOW_START,
    UPDATE_SLEEP_WINDOW_SUCCESS,
    UPDATE_SLEEP_WINDOW_FAIL,
    ADD_SLEEP_START,
    ADD_SLEEP_FAIL,
    ADD_SLEEP_SUCCESS,
    RESET_DAILY_SLEEP,
    SET_OPEN_TAB_ON_SLEEP_ONE_DAY_VIEW,
    FETCH_HRV_DAILY_FETCHING,
    FETCH_HRV_DAILY_SUCCESS,
    FETCH_HRV_DAILY_FAIL,
    FETCH_NAP_BY_DATE_FETCHING,
    FETCH_NAP_BY_DATE_SUCCESS,
    FETCH_NAP_BY_DATE_FAIL,
    ADD_NAP_START,
    ADD_NAP_SUCCESS,
    FETCH_DAILY_SLEEP_SUCCESS,
    FETCH_DAILY_SLEEP_FAIL,
    DELETE_NAP_FAIL
} from '../../actions/ActionTypes.js';

import { SKIN_TEMP_MIN_MAX_VALUES } from 'utils/sleep/SleepConstants';

const INITIAL_STATE = {
    dailySleeps: {},
    isFetching: {},
    fetchFailed: {},
    noteUpdating: false,
    noteUpdateFailed: false,
    lastNote: '',
    sleepWindowUpdating: false,
    sleepWindowUpdateFailed: false,
    dailySleepAdding: false,
    dailySleepAddingFailed: false,
    openTab: null,
    dailyNaps: {
        isFetching: {},
        fetchFailed: {},
        fetchSuccess: {},
        naps: {},
        isAddingNap: false,
        isAddingNapSuccess: false,
        isAddingNapFailed: false
    },
    hrvStatus: {
        isFetching: {},
        fetchFailed: {},
        hrv: {}
    }
};

const fetchDailySleepDataFetching = (state, action) => {
    return {
        ...state,
        isFetching: {
            ...state.isFetching,
            [action.calendarDate]: true
        },
        fetchFailed: {
            ...state.fetchFailed,
            [action.calendarDate]: false
        }
    };
};

const fetchDailySleepDataSuccess = (state, action) => {
    return {
        ...state,
        dailySleeps: {
            ...state.dailySleeps,
            [action.calendarDate]: action.dailySleepData
        },
        isFetching: {
            ...state.isFetching,
            [action.calendarDate]: false
        },
        fetchFailed: {
            ...state.fetchFailed,
            [action.calendarDate]: false
        }
    };
};

const fetchDailySleepDataFail = (state, action) => {
    return {
        ...state,
        dailySleeps: {
            ...state.dailySleeps,
            [action.calendarDate]: {}
        },
        isFetching: {
            ...state.isFetching,
            [action.calendarDate]: false
        },
        fetchFailed: {
            ...state.fetchFailed,
            [action.calendarDate]: true
        }
    };
};

const updateSleepNoteStart = (state, action) => {
    const { userNote, calendarDate } = action;

    return {
        ...state,
        dailySleeps: {
            ...state.dailySleeps,
            [calendarDate]: {
                ...state.dailySleeps[calendarDate],
                dailySleepDTO: {
                    ...state.dailySleeps[calendarDate].dailySleepDTO,
                    userNote
                }
            }
        },
        noteUpdating: true
    };
};

const updateSleepNote = (state, action) => {
    const { userNote } = action;

    return {
        ...state,
        noteUpdating: INITIAL_STATE.noteUpdating,
        noteUpdateFailed: INITIAL_STATE.noteUpdateFailed,
        lastNote: userNote
    };
};

const updateSleepNoteFail = (state, action) => {
    const { calendarDate } = action;

    return {
        ...state,
        dailySleeps: {
            ...state.dailySleeps,
            [calendarDate]: {
                ...state.dailySleeps[calendarDate],
                dailySleepDTO: {
                    ...state.dailySleeps[calendarDate].dailySleepDTO,
                    userNote: state.lastNote
                }
            }
        },
        noteUpdating: INITIAL_STATE.noteUpdating,
        noteUpdateFailed: true
    };
};

const updateSleepWindowStart = (state) => {
    return {
        ...state,
        sleepWindowUpdating: true,
        sleepWindowUpdateFailed: INITIAL_STATE.sleepWindowUpdateFailed
    };
};

const updateSleepWindowSuccess = (state, action) => {
    const { dailySleepData, calendarDate } = action;

    return {
        ...state,
        dailySleeps: {
            ...state.dailySleeps,
            [calendarDate]: dailySleepData
        },
        sleepWindowUpdating: INITIAL_STATE.sleepWindowUpdating,
        sleepWindowUpdateFailed: INITIAL_STATE.sleepWindowUpdateFailed
    };
};

const updateSleepWindowFail = (state, action) => {
    const { calendarDate } = action;

    return {
        ...state,
        dailySleeps: {
            ...state.dailySleeps,
            [calendarDate]: null
        },
        sleepWindowUpdating: INITIAL_STATE.sleepWindowUpdating,
        sleepWindowUpdateFailed: true
    };
};

const addSleepStart = (state) => {
    return {
        ...state,
        dailySleepAdding: true,
        dailySleepAddingFailed: INITIAL_STATE.dailySleepAddingFailed
    };
};

const addSleepSuccess = (state, action) => {
    const { dailySleepData, calendarDate } = action;

    return {
        ...state,
        dailySleeps: {
            ...state.dailySleeps,
            [calendarDate]: dailySleepData
        },
        dailySleepAdding: INITIAL_STATE.dailySleepAdding,
        dailySleepAddingFailed: INITIAL_STATE.dailySleepAddingFailed
    };
};

const addSleepFail = (state, action) => {
    const { calendarDate } = action;

    return {
        ...state,
        dailySleeps: {
            ...state.dailySleeps,
            [calendarDate]: null
        },
        dailySleepAdding: INITIAL_STATE.dailySleepAdding,
        dailySleepAddingFailed: true
    };
};

const resetDailySleep = (state) => {
    return {
        ...state,
        dailySleepAdding: INITIAL_STATE.dailySleepAdding,
        dailySleepAddingFailed: INITIAL_STATE.dailySleepAddingFailed
    };
};

const setOpenTabOnSleepOneDayView = (state, action) => {
    const { tab } = action;
    return {
        ...state,
        openTab: tab
    };
};

const dailyNapsFetching = (state, action) => {
    return {
        ...state,
        dailyNaps: {
            ...state.dailyNaps,
            isFetching: {
                ...state.dailyNaps.isFetching,
                [action.calendarDate]: true
            },
            fetchFailed: {
                ...state.dailyNaps.fetchFailed,
                [action.calendarDate]: false
            },
            fetchSuccess: {
                ...state.dailyNaps.fetchSuccess,
                [action.calendarDate]: false
            }
        }
    };
};

const addNapStart = (state, action) => {
    return {
        ...state,
        dailyNaps: {
            ...state.dailyNaps,
            isAddingNap: true,
            isAddingNapSuccess: false
        }
    };
};

const addNapSuccess = (state, action) => {
    return {
        ...state,
        dailyNaps: {
            ...state.dailyNaps,
            isAddingNap: false,
            isAddingNapSuccess: true
        }
    };
};

const fetchDailySleepSuccess = (state, action) => {
    return {
        ...state,
        dailySleeps: {
            ...state.dailySleeps,
            [action.calendarDate]: {
                ...state.dailySleeps[action.calendarDate],
                dailySleepDTO: {
                    ...action.payload,
                    dailyNapDTOS: action.payload.dailyNapDTOS
                }
            }
        }
    };
};

const fetchDailySleepFail = (state, action) => {
    return {
        ...state,
        dailySleeps: {
            ...state.dailySleeps,
            [action.calendarDate]: {
                ...state.dailySleeps[action.calendarDate]
            }
        }
    };
};

const deleteNapFail = (state, action) => {
    return {
        ...state,
        dailySleeps: {
            ...state.dailySleeps,
            [action.calendarDate]: {
                ...state.dailySleeps[action.calendarDate],
                dailySleepDTO: {
                    ...state.dailySleeps[action.calendarDate].dailySleepDTO,
                    dailyNapDTOS: state.dailySleeps[action.calendarDate].dailySleepDTO.dailyNapDTOS
                }
            }
        }
    };
};

const dailyNapsFetchingSuccess = (state, action) => {
    return {
        ...state,
        dailyNaps: {
            ...state.dailyNaps,
            naps: {
                ...state.dailyNaps.naps,
                [action.calendarDate]: action.dailyNapData
            },
            isFetching: {
                ...state.dailyNaps.isFetching,
                [action.calendarDate]: false
            },
            fetchFailed: {
                ...state.dailyNaps.fetchFailed,
                [action.calendarDate]: false
            },
            fetchSuccess: {
                ...state.dailyNaps.fetchSuccess,
                [action.calendarDate]: true
            }
        },
        dailySleeps: {
            ...state.dailySleeps,
            [action.calendarDate]: {
                ...state.dailySleeps[action.calendarDate],
                dailySleepDTO: {
                    ...state.dailySleeps[action.calendarDate].dailySleepDTO,
                    dailyNapDTOS: action.dailyNapData
                }
            }
        }
    };
};

const dailyNapsFetchingFail = (state, action) => {
    return {
        ...state,
        dailyNaps: {
            ...state.dailyNaps,
            naps: {
                ...state.dailyNaps.naps,
                [action.calendarDate]: {}
            },
            isFetching: {
                ...state.dailyNaps.isFetching,
                [action.calendarDate]: false
            },
            fetchFailed: {
                ...state.dailyNaps.fetchFailed,
                [action.calendarDate]: true
            },
            fetchSuccess: {
                ...state.dailyNaps.fetchSuccess,
                [action.calendarDate]: false
            }
        }
    };
};

const hrvDailyFetching = (state, action) => {
    const key = action.startDate + action.endDate;
    return {
        ...state,
        hrvStatus: {
            ...state.hrvStatus,
            isFetching: {
                ...state.hrvStatus.isFetching,
                [key]: true
            },
            fetchFailed: {
                ...state.hrvStatus.fetchFailed,
                [key]: false
            }
        }
    };
};

const hrvDailyFetchingSuccess = (state, action) => {
    const key = action.startDate + action.endDate;
    return {
        ...state,
        hrvStatus: {
            ...state.hrvStatus,
            hrv: {
                ...state.hrvStatus.hrv,
                [key]: action.hrvData
            },
            isFetching: {
                ...state.hrvStatus.isFetching,
                [key]: false
            },
            fetchFailed: {
                ...state.hrvStatus.fetchFailed,
                [key]: false
            }
        }
    };
};

const hrvDailyFetchingFail = (state, action) => {
    const key = action.startDate + action.endDate;
    return {
        ...state,
        hrvStatus: {
            ...state.hrvStatus,
            hrv: {
                ...state.hrvStatus.hrv,
                [key]: {}
            },
            isFetching: {
                ...state.hrvStatus.isFetching,
                [key]: false
            },
            fetchFailed: {
                ...state.hrvStatus.fetchFailed,
                [key]: true
            }
        }
    };
};

const handlers = {
    [FETCH_DAILY_SLEEP_DATA_WITH_EPOCHS_FETCHING]: fetchDailySleepDataFetching,
    [FETCH_DAILY_SLEEP_DATA_WITH_EPOCHS_SUCCESS]: fetchDailySleepDataSuccess,
    [FETCH_DAILY_SLEEP_DATA_WITH_EPOCHS_FAIL]: fetchDailySleepDataFail,
    [UPDATE_SLEEP_NOTE_START]: updateSleepNoteStart,
    [UPDATE_SLEEP_NOTE_SUCCESS]: updateSleepNote,
    [UPDATE_SLEEP_NOTE_FAIL]: updateSleepNoteFail,
    [UPDATE_SLEEP_WINDOW_START]: updateSleepWindowStart,
    [UPDATE_SLEEP_WINDOW_SUCCESS]: updateSleepWindowSuccess,
    [UPDATE_SLEEP_WINDOW_FAIL]: updateSleepWindowFail,
    [ADD_SLEEP_START]: addSleepStart,
    [ADD_SLEEP_SUCCESS]: addSleepSuccess,
    [ADD_SLEEP_FAIL]: addSleepFail,
    [RESET_DAILY_SLEEP]: resetDailySleep,
    [SET_OPEN_TAB_ON_SLEEP_ONE_DAY_VIEW]: setOpenTabOnSleepOneDayView,
    [FETCH_HRV_DAILY_FETCHING]: hrvDailyFetching,
    [FETCH_HRV_DAILY_SUCCESS]: hrvDailyFetchingSuccess,
    [FETCH_HRV_DAILY_FAIL]: hrvDailyFetchingFail,
    [FETCH_NAP_BY_DATE_FETCHING]: dailyNapsFetching,
    [FETCH_NAP_BY_DATE_SUCCESS]: dailyNapsFetchingSuccess,
    [FETCH_NAP_BY_DATE_FAIL]: dailyNapsFetchingFail,
    [ADD_NAP_START]: addNapStart,
    [ADD_NAP_SUCCESS]: addNapSuccess,
    [DELETE_NAP_FAIL]: deleteNapFail,
    [FETCH_DAILY_SLEEP_SUCCESS]: fetchDailySleepSuccess,
    [FETCH_DAILY_SLEEP_FAIL]: fetchDailySleepFail
};

export default function dailySleepEpochs(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

export const getDailySleepDataWithEpochs = (state, calendarDate, isMetricMeasurementSystem) => {
    const dailySleep = state.dailySleepEpochs.dailySleeps[calendarDate];
    if (!dailySleep) {
        return null;
    }

    return {
        ...dailySleep,
        skinTempData: dailySleep.skinTempData
            ? dailySleep.skinTempData.map((reading) => {
                  let value = isMetricMeasurementSystem ? reading.deviationCelsius : reading.deviationFahrenheit;

                  if (value === undefined || isNaN(value)) {
                      value = null;
                  }

                  if (isMetricMeasurementSystem) {
                      if (value > SKIN_TEMP_MIN_MAX_VALUES.MAX_C || value < SKIN_TEMP_MIN_MAX_VALUES.MIN_C) {
                          value = null;
                      }
                  } else if (value > SKIN_TEMP_MIN_MAX_VALUES.MAX_F || value < SKIN_TEMP_MIN_MAX_VALUES.MIN_F) {
                      value = null;
                  }

                  return {
                      ...reading,
                      value
                  };
              })
            : null
    };
};

export const isDailySleepDataWithEpochsFetchingByDate = (state, calendarDate) => {
    return state.dailySleepEpochs.isFetching ? state.dailySleepEpochs.isFetching[calendarDate] : false;
};

export const isDailySleepDataWithEpochsFetchFailByDate = (state, calendarDate) => {
    return state.dailySleepEpochs.fetchFailed ? state.dailySleepEpochs.fetchFailed[calendarDate] : false;
};

export const hasNoteUpdateFailed = (state) => {
    return state.dailySleepEpochs.noteUpdateFailed;
};

export const isSleepWindowUpdating = (state) => {
    return state.dailySleepEpochs.sleepWindowUpdating;
};

export const hasUpdateSleepWindowFailed = (state) => {
    return state.dailySleepEpochs.sleepWindowUpdateFailed;
};

export const isDailySleepAdding = (state) => {
    return state.dailySleepEpochs.dailySleepAdding;
};

export const hasAddSleepFailed = (state) => {
    return state.dailySleepEpochs.dailySleepAddingFailed;
};

export const getSleepOneDayViewOpenTab = (state) => {
    return state.dailySleepEpochs.openTab;
};

export const isDailyNapsByDateFetching = (state, calendarDate) => {
    return state.dailySleepEpochs.dailyNaps.isFetching
        ? state.dailySleepEpochs.dailyNaps.isFetching[calendarDate]
        : false;
};

export const isDailyNapsByDateFail = (state, calendarDate) => {
    return state.dailySleepEpochs.dailyNaps.fetchFailed
        ? state.dailySleepEpochs.dailyNaps.fetchFailed[calendarDate]
        : false;
};

export const isDailyNapsByDateSuccess = (state, calendarDate) => {
    return state.dailySleepEpochs.dailyNaps.fetchSuccess
        ? state.dailySleepEpochs.dailyNaps.fetchSuccess[calendarDate]
        : false;
};

export const isAddingNapByDate = (state) => {
    return state.dailySleepEpochs.dailyNaps.isAddingNap ? state.dailySleepEpochs.dailyNaps.isAddingNap : false;
};

export const isAddingNapSuccessByDate = (state) => {
    return state.dailySleepEpochs.dailyNaps.isAddingNapSuccess
        ? state.dailySleepEpochs.dailyNaps.isAddingNapSuccess
        : false;
};

export const getDailyNapsByDate = (state, calendarDate) => {
    return state.dailySleepEpochs.dailySleeps[calendarDate].dailySleepDTO.dailyNapDTOS;
};

export const isHrvDailyFetching = (state, startDate, endDate) => {
    return state.dailySleepEpochs.hrvStatus.isFetching
        ? state.dailySleepEpochs.hrvStatus.isFetching[startDate + endDate]
        : false;
};

export const isHrvDailyFail = (state, startDate, endDate) => {
    return state.dailySleepEpochs.hrvStatus.fetchFailed
        ? state.dailySleepEpochs.hrvStatus.fetchFailed[startDate + endDate]
        : false;
};

export const getHrvDaily = (state, startDate, endDate) => {
    return state.dailySleepEpochs.hrvStatus.hrv[startDate + endDate];
};
